(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('AssetDetailController', AssetDetailController);

    AssetDetailController.$inject = ['$scope', '$rootScope', '$stateParams','$state', 'pagingParams', 'ParseLinks', 'paginationConstants','previousState', 'entity', 'Asset', 'User', 'AssetType','$localStorage','Configs','MappedFixedAssets','UserAccount'];

    function AssetDetailController($scope, $rootScope, $stateParams,$state, pagingParams, ParseLinks, paginationConstants,previousState, entity, Asset, User, AssetType,$localStorage,Configs,MappedFixedAssets,UserAccount) {
        var vm = this;

        vm.asset = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        var locations = {};
        vm.isMapVisible = false;

        if(vm.asset.id!=null && vm.asset.assetType.layout=='SPREAD'){
            vm.asset.assetCoordinates.sort(function (a, b) {
                // Sort by sortOrder, placing null or undefined at the end
                if (a.sortOrder == null && b.sortOrder != null) {
                    return 1;
                } else if (a.sortOrder != null && b.sortOrder == null) {
                    return -1;
                } else if (a.sortOrder != null && b.sortOrder != null) {
                    // Both have sortOrder, compare numerically
                    return a.sortOrder - b.sortOrder;
                } else {
                    // Both sortOrder are null, fallback to id comparison
                    return a.id - b.id;
                }
            });
        }
        

        var assetCoor = [];
        vm.asset.assetCoordinates.forEach(function (val) {
            assetCoor.push({
                lat: val.latitude,
                lng: val.longitude,
            });
        });
        locations.map = new google.maps.Map(
            document.getElementById("map_canvas"),
            myOption(
                12,assetCoor[0]
            )
        );
         UserAccount.get(function (data) {
                var isAdmin = false;
                data.authorities.forEach(function (val) {
                    if(val == "ROLE_READONLY"){
                        vm.has_ROLE_READONLY=true
                    }
                })
         })

        if(vm.asset.assetType.layout=='FIXED'){
            var infowindow = new google.maps.InfoWindow();
            var fixed = vm.asset;
            var iconUrl = "";
            var isFixedAsset = false;
            iconUrl = fixed.assetType.imagePath;
            isFixedAsset = true;

            var iconSize = 8;
            if (vm.zoomLevel == 10) {
                iconSize = 8;
            } else if (vm.zoomLevel == 11) {
                iconSize = 16;
            }

            if (isFixedAsset) {
                iconSize = 24;
            }

            var startMarker = new google.maps.Marker({
                map: locations.map,
                position: assetCoor[0],
                title: fixed.name,
                icon: {
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                    url: iconUrl,
                    anchor: new google.maps.Point(
                        iconSize / 2,
                        iconSize / 2
                    ),
                },
            });
            google.maps.event.addListener(
                startMarker,
                "mouseout",
                function (event) {
                    infowindow.close();
                }
            );

            google.maps.event.addListener(
                startMarker,
                "click",
                function (event) {
                    infowindow.setContent(
                        '<div class="infoWindowhead">' +
                        "<b>Asset Name : </b><br><br>" +
                        fixed.name +
                        "</br></div>"
                    );

                    infowindow.mousemove;
                    infowindow.open(locations.map);
                    infowindow.setPosition(event.latLng);
                }
            );
        } else {
            var spreadAsset = new google.maps.Polyline({
                path: assetCoor,
                strokeColor: vm.asset.assetType.colorcode
            });
            spreadAsset.setMap(locations.map);
        }
        

        

        vm.toggleMap = function () {
            vm.isMapVisible = !vm.isMapVisible;
        };
        vm.showImages = function () {
            if (vm.asset && vm.asset.assetImages.length) {
                var token = $localStorage.authenticationToken;
                gpName = vm.asset.name || "Images";
                  var validTypes = ['.PNG', 'PNG', 'PDF', '.PDF', 'JPEG', '.JPEG', 'JPG', '.JPG', 'MP4', '.MP4'];
                var imageMetaList = vm.asset.assetImages.filter(function (img) {
                    var type = img.imageType ? img.imageType.toUpperCase() : '';
                    return validTypes.indexOf(type) !== -1;
                }).sort(function (a, b) {
                    return a.createdDate - b.createdDate;
                }).map(function (img) {
                    return {
                        url: img.imageUrl || ('/api/trakeyeassetimages/' + vm.asset.id + '/' + img.imageId),
                        type: img.imageType ? img.imageType.toUpperCase() : 'PNG',
                        createdDate: img.createdDate
                    };
                });
                if (imageMetaList.length) {
                    preloadImagesWithToken(imageMetaList, token);
                } else {
                    alert("No images or PDFs found.");
                }
            } else {
                alert("No images or PDFs found.");
            }
        }
         var carouselImages = [];
        var currentImageIndex = 0;
        var gpName = 'images';
        function preloadImagesWithToken(imageMetaList, token) {
            var blobUrls = [];
            var remaining = imageMetaList.length;
            var hasError = false;

            for (var i = 0; i < imageMetaList.length; i++) {
                (function (img, index) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', img.url, true);
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        if (xhr.status === 200 && xhr.response) {
                            var metaType = img.type ? img.type.toUpperCase() : '';
                            var type = metaType.includes("PDF") ? "PDF" :
                                metaType.includes("MP4") ? "VIDEO" :
                                    "IMAGE";
                            blobUrls[index] = {
                                url: URL.createObjectURL(xhr.response),
                                type: type
                            };
                        } else {
                            hasError = true;
                        }
                        remaining--;
                        if (remaining === 0) {
                            if (hasError) alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.onerror = function () {
                        hasError = true;
                        remaining--;
                        if (remaining === 0) {
                            alert("Failed to load one or more files.");
                            var finalBlobUrls = blobUrls.filter(function (item) { return !!item; });
                            openCarousel(finalBlobUrls);
                        }
                    };
                    xhr.send();
                })(imageMetaList[i], i);
            }
        }

        function openCarousel(images) {
            carouselImages = images;
            currentImageIndex = 0;
            document.getElementById("imageCarouselModal").style.display = "flex";
            updateCarouselImage();
            generateThumbnails();
        }

        function updateCarouselImage() {
            var container = document.getElementById("carouselDisplayContainers");
            container.innerHTML = "";
            if (!carouselImages.length || !carouselImages[currentImageIndex]) {
                console.warn("No valid media found at index:", currentImageIndex);
                return;
            }
            var current = carouselImages[currentImageIndex];
            if (current.type === "PDF") {
                var iframe = document.createElement("iframe");
                iframe.src = current.url;
                iframe.className = "carousel-pdf";
                container.appendChild(iframe);
            } else if (current.type === "VIDEO") {
                var video = document.createElement("video");
                video.src = current.url;
                video.controls = true;
                video.autoplay = true;
                video.className = "carousel-video";
                container.appendChild(video);
            } else {
                var img = document.createElement("img");
                img.className = "carousel-image";
                img.src = current.url;
                img.id = "carouselImage";
                img.style.cursor = "grab";
                img.setAttribute("draggable", "false");
                container.appendChild(img);

                // Zoom + Drag behavior
                var zoom = 1;
                var minZoom = 1;
                var maxZoom = 5;
                var imgOffsetX = 0;
                var imgOffsetY = 0;

                function applyTransform() {
                    img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                    img.style.transition = "transform 0.1s ease-out";
                }

                applyTransform();

                container.addEventListener("wheel", function (e) {
                    e.preventDefault();
                    var delta = Math.sign(e.deltaY);
                    var zoomAmount = 0.10;
                    var newZoom = zoom;

                    if (delta < 0) {
                        newZoom = Math.min(maxZoom, zoom + zoomAmount);
                    } else {
                        newZoom = Math.max(minZoom, zoom - zoomAmount);
                    }

                    var scaleFactor = newZoom / zoom;
                    var rect = img.getBoundingClientRect();
                    var mouseX = e.clientX - rect.left;
                    var mouseY = e.clientY - rect.top;

                    if (newZoom === minZoom) {
                        imgOffsetX = 0;
                        imgOffsetY = 0;
                    } else {
                        imgOffsetX -= mouseX * scaleFactor - mouseX;
                        imgOffsetY -= mouseY * scaleFactor - mouseY;
                    }

                    zoom = newZoom;
                    applyTransform();
                });

                var isDragging = false;
                var startCursorX, startCursorY;
                var startImgOffsetX, startImgOffsetY;

                img.addEventListener("mousedown", function (e) {
                    isDragging = true;
                    img.style.cursor = "grabbing";
                    startCursorX = e.clientX;
                    startCursorY = e.clientY;
                    startImgOffsetX = imgOffsetX;
                    startImgOffsetY = imgOffsetY;
                    img.style.transition = "none";
                });

                document.addEventListener("mouseup", function () {
                    isDragging = false;
                    img.style.cursor = "grab";
                });

                document.addEventListener("mousemove", function (e) {
                    if (!isDragging) return;
                    e.preventDefault();
                    var dx = e.clientX - startCursorX;
                    var dy = e.clientY - startCursorY;
                    imgOffsetX = startImgOffsetX + dx;
                    imgOffsetY = startImgOffsetY + dy;
                    applyTransform();
                });
            }
        }

        function generateThumbnails() {
            var container = document.getElementById("carouselThumbnails");
            container.innerHTML = "";

            for (var i = 0; i < carouselImages.length; i++) {
                (function (index) {
                    var current = carouselImages[index];
                    var thumb = document.createElement("img");

                    thumb.src = current.type === "PDF"
                        ? "content/images/pdf_file_icon.png"
                        : current.type === "VIDEO"
                            ? "content/images/video_icon.png"
                            : current.url;

                    console.log("Thumbnail src for type", current.type, "->", thumb.src);

                    thumb.className = "carousel-thumbnail";
                    if (index === currentImageIndex) {
                        thumb.classList.add("selected");
                    }

                    thumb.onclick = function () {
                        currentImageIndex = index;
                        updateCarouselImage();
                        generateThumbnails();
                    };

                    container.appendChild(thumb);
                })(i);
            }
        }

        window.closeCarousel = function () {
            document.getElementById("imageCarouselModal").style.display = "none";
        };

        window.changeImage = function (n) {
            currentImageIndex += n;
            if (currentImageIndex < 0) currentImageIndex = carouselImages.length - 1;
            if (currentImageIndex >= carouselImages.length) currentImageIndex = 0;
            updateCarouselImage();
            generateThumbnails();
        };

        window.downloadCurrentImage = function () {
            var current = carouselImages[currentImageIndex];
            var link = document.createElement('a');
            link.href = current.url;
             var extension = current.type === "PDF" ? ".pdf" :
                    current.type === "VIDEO" ? ".mp4" :
                    ".png"; 
            link.download = gpName + "_gpfile_" + (currentImageIndex + 1)+extension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        window.downloadAllImages = function () {
            var spinner = document.getElementById("loading-bar-spinner");
            if (spinner) {
                spinner.style.display = "block";
            }
            var xhr = new XMLHttpRequest();
            xhr.open('GET', '/api/assets/downloadFiles/' + vm.asset.id, true);
            xhr.setRequestHeader('Accept', 'application/zip');
            xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
            xhr.responseType = 'blob';

            xhr.onload = function () {
                if (spinner) {
                    spinner.style.display = "none"; // Show the spinner
                }
                if (xhr.status === 200) {
                    var blob = new Blob([xhr.response], { type: 'application/zip' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = vm.asset.name + '_GP' + '.zip';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert('Download failed. Status: ' + xhr.status);
                }
            };

            xhr.onerror = function () {
                alert('Request error.');
            };

            xhr.send();
        }
        $scope.tab = 1;
        $scope.isSet = function (tabNum) {
            return $scope.tab === tabNum;
        };
        $scope.setTab = function (newTab) {
            $scope.tab = newTab; 
            if ($scope.tab == 2) { 
                MappedFixedAssets.get(vm.asset.id,pagingParams.page - 1,vm.itemsPerPage, function(response){
                    vm.links = ParseLinks.parse(response.headers("link"));
                    vm.totalItems = response.headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                    vm.listMappedAssets = response.data
                    vm.page = pagingParams.page;
                })
            }
        }
        vm.previousState = previousState.name;
        //vm.showAssetImage = false

        /* Configs.get("AssetImage",function(response){
            if(response.length > 0){
                if(response[0].configValue == "True"){
                    vm.showAssetImage = true
                }
            }
        }) */
        if(vm.asset.assetReferenceAttributes.length){
            vm.assetRefAttributes = []
            vm.asset.assetReferenceAttributes.forEach(function (get){
                if (get["assetAttributeName"] != null) {
                    get['assetAttributeName'].assetTypeAttribute.attributeValue = get['assetAttributeName'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeName'].assetTypeAttribute);
                }

                if (get["assetAttributeValue"] != null) {
                    get['assetAttributeValue'].assetTypeAttribute.attributeValue = get['assetAttributeValue'].attributeValue;
                    vm.assetRefAttributes.push(get['assetAttributeValue'].assetTypeAttribute);
                }

                if (get["assetAttributeImage"] != null) {
                    get['assetAttributeImage'].assetTypeAttribute.imageId = get['assetAttributeImage'].imageId;
                    get['assetAttributeImage'].assetTypeAttribute.attributeName = get['assetAttributeImage'].imageName;
                    vm.assetRefAttributes.push(get['assetAttributeImage'].assetTypeAttribute);
                }
            })
        }

       /*  vm.imageInNewTab = function (img) {
		    var imgWindow = window.open();
            imgWindow.document.write(
                '<img width="25%"   src="data:image/jpeg;base64,' +
                    img +
                    '">'
            );
            imgWindow.document.close(); 
		}; */
        vm.transition = function transition() {
          /*  if(vm.queryCount )
            MappedFixedAssets.get(vm.asset.id,vm.page,vm.itemsPerPage, function(response){
                vm.links = ParseLinks.parse(response.headers("link"));
                vm.totalItems = response.headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.totalItems = Math.ceil(vm.queryCount / vm.itemsPerPage) * 10;
                vm.listMappedAssets = response.data
                vm.page = pagingParams.page;
            }) */
        }
$scope.showAllImages = function (images, name) {
    if (!images || images.length === 0) {
        alert("No images available for this attribute.");
        return;
    }

    var apiBase = name === 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";
    var imageBlobs = [];
    var loadedCount = 0;
    // Open a new tab immediately
    var imageWindow = window.open("", "_blank");
    imageWindow.document.title = "Attribute Images";
    imageWindow.document.write("<h2 style='font-family:Arial; color:#3c8dbc;'>Attribute Images</h2>");
    imageWindow.document.write("<div id='imageContainer' style='display:flex; flex-wrap:wrap; gap:10px;'></div>");

    images.forEach(function (img) {
        if (!img.imageId) return;

        var request = new XMLHttpRequest();
        request.open('GET', apiBase + vm.asset.id + "/" + img.imageId, true);
        request.setRequestHeader('Authorization', 'Bearer ' + $localStorage.authenticationToken);
        request.responseType = 'blob';
        
        request.onload = function () {
            loadedCount++;
            if (this.status === 200) {
                var urlCreator = window.URL || window.webkitURL;
                var blobUrl = urlCreator.createObjectURL(this.response);
                // Append image to the new tab dynamically
                var container = imageWindow.document.getElementById('imageContainer');
                var imgTag = imageWindow.document.createElement('img');
                imgTag.src = blobUrl;
                imgTag.style.maxWidth = "250px";
                imgTag.style.border = "1px solid #ccc";
                imgTag.style.borderRadius = "6px";
                imgTag.style.margin = "5px";
                container.appendChild(imgTag);
            }

            if (loadedCount === images.length) {
                imageWindow.document.write("<p style='font-family:Arial; color:gray;'>All images loaded.</p>");
            }
        };

        request.onerror = function () {
            loadedCount++;
            console.error("Error loading image:", img.imageId);
        };

        request.send();
    });
};


        $scope.newTabDisplay = function(id,name,str){
            var request = new XMLHttpRequest(),apiImage = name == 'reference' ? "api/trakeyeassetrefimages/" : "api/trakeyeassetimages/";;
            request.open('GET',apiImage+vm.asset.id+"/"+id, true);
            request.setRequestHeader('Authorization', 'Bearer '+$localStorage.authenticationToken);
            request.responseType = 'blob';
            request.onload = response;
            
            function response(e) {
                if (this.status === 200) {
                    var urlCreator = window.URL || window.webkitURL;
                  
                    
                    if(str == "MP4"){
                        var videoUrl = urlCreator.createObjectURL(this.response);
                        
                        var video = document.createElement('video');
                        video.src = videoUrl;
                        video.controls = true;
                        video.autoplay = true;
                
                        var videoWindow = window.open("", "_blank");
                        videoWindow.document.body.appendChild(video);
                    }else{
                        var imageUrl = urlCreator.createObjectURL(this.response);
                        window.open(imageUrl, "_blank");
                    }
                   
                }
            } 
            request.send();
        } 

        var unsubscribe = $rootScope.$on('trakeyeApp:assetUpdate', function(event, result) {
            vm.asset = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
    
    function myOption(zoom, center) {
        var myOptions;
        return (myOptions = {
            zoom: zoom,
            center: center,
            scaleControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                } /* 
                {
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#EFEFEF",
                        },
                    ],
                }, */,
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            color: "#63666A",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
                {
                    featureType: "landscape",
                    stylers: [
                        {
                            color: "#efefef",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#ffffff",
                        },
                    ],
                },
            ],
        });
    }
})();
